<template>
  <div>
    <div
      class="mb-5"
      :class="!$vuetify.breakpoint.mobile ? 'd-flex' : 'd-block'"
    >
      <AppointmentQuoteAlerts
        :isLoading="isLoading"
        :appointment="appointment"
        :isQuotePending="isQuotePending"
        :quoteWasNotFound="quoteWasNotFound"
        :isQuoteAlreadyPaid="isQuoteAlreadyPaid"
      />
      <AppointmentOtherValues :transferId="appointment.transfer_id" />
    </div>
    <AppointmentQuoteShareInfo />

    <v-card
      v-if="vendor"
      color="grey lighten-4"
      class="mb-10 pa-5"
      outlined
    >
      <div
        :class="!$vuetify.breakpoint.mobile ? 'd-flex' : 'd-block'"
        class="align-center"
      >
        <img
          v-if="vendor.logo"
          :src="vendor.logo.url"
          :alt="vendor.name"
          class="d-block mw-150 rounded-lg elevation-2 elevation-opacity-2"
          width="100%"
        />
        <v-divider
          v-if="!$vuetify.breakpoint.mobile"
          class="d-block mh-45 my-auto mx-5"
          vertical
        />
        <v-spacer v-else class="my-4" />
        <div class="d-block">
          <div class="mw-300">
            <h4 class="text-truncate">
              {{ vendor.name }}
            </h4>
          </div>
          <p v-if="vendor.document" class="caption mb-0 grey--text grey--text">
            {{ formatDocument(vendor.document) }}
          </p>
        </div>
        <v-divider
          v-if="!$vuetify.breakpoint.mobile"
          class="d-block mh-45 my-auto mx-5"
          vertical
        />
        <v-spacer v-else class="my-3" />
        <div class="d-block">
          <p class="caption mb-0 grey--text grey--text">
            {{ $t('quote.label.phone') }}
          </p>
          <span v-if="vendor.customer_service_phone" v-html="whatsApp(vendor.customer_service_phone)" class="body-2" />
          <span v-else> --- </span>
        </div>
        <v-divider
          v-if="!$vuetify.breakpoint.mobile"
          class="d-block mh-45 my-auto mx-5"
          vertical
        />
        <v-spacer v-else class="my-3" />
        <div class="d-block">
          <p class="caption mb-0 grey--text grey--text">
            {{ $t('quote.label.email') }}
          </p>
          <a
            v-if="vendor.email"
            :href="`mailto:${vendor.email}`"
            class="body-2"
          >
            {{ vendor.email }}
          </a>
          <span v-else class="body-2"> --- </span>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import AppointmentOtherValues from './AppointmentOtherValues'
import AppointmentQuoteAlerts from './AppointmentQuoteAlerts'
import AppointmentQuoteShareInfo from './AppointmentQuoteShareInfo'

import { mapGetters } from 'vuex'
import { formatDocument } from '@/util/document'

import {
  whatsApp,
  catalogDate,
  catalogPhone,
  catalogMonetary,
} from '@/util/catalog'

export default {
  name: 'AppointmentQuoteInfo',

  components: {
    AppointmentOtherValues,
    AppointmentQuoteAlerts,
    AppointmentQuoteShareInfo,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },

    quoteWasNotFound: {
      type: Boolean,
      default: false,
    },

    isQuoteAlreadyPaid: {
      type: Boolean,
      default: false,
    },

    isQuotePending: {
      type: Boolean,
      default: false,
    },

    vendor: {
      type: Object,
    },

    appointment: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters(['serviceReport']),
  },

  data() {
    return {
      formatPhone: catalogPhone,
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
      formatDocument,
      whatsApp,
    }
  },
}
</script>
